if (!customElements.get('iwt-group')) {
  class IwtGroup extends HTMLElement {
    connectedCallback() {
      this._mode = this.dataset.mode;
      if (this._mode !== 'scroll_reveal') return;

      this._items = Array.from(this.querySelectorAll('.iwtg__item'));
      if (this._items.length === 0) return;

      this._currentIndex = 0;
      this._dotNav = null;
      this._dots = [];

      this._buildDotNav();
      this._activateIndex(0, false);

      this._onScroll = this._handleScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      this._dotNav?.remove();
    }

    _buildDotNav() {
      if (this._items.length < 2) return;
      this._dotNav = document.createElement('div');
      this._dotNav.className = 'iwtg__dot-nav';
      this._dotNav.setAttribute('aria-hidden', 'true');
      this._items.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'iwtg__dot-nav__dot';
        dot.setAttribute('aria-label', `Go to item ${i + 1}`);
        dot.addEventListener('click', () => this._scrollToIndex(i));
        this._dotNav.appendChild(dot);
        this._dots.push(dot);
      });
      document.body.appendChild(this._dotNav);
    }

    _scrollToIndex(index) {
      const sectionTop = this.getBoundingClientRect().top + window.scrollY;
      const scrollableRange = this.offsetHeight - window.innerHeight;
      if (scrollableRange <= 0) return;
      const fraction = index / this._items.length;
      window.scrollTo({ top: sectionTop + fraction * scrollableRange + 1, behavior: 'smooth' });
    }

    _handleScroll() {
      const rect = this.getBoundingClientRect();
      const sectionHeight = this.offsetHeight;
      const viewportHeight = window.innerHeight;
      const scrollableRange = sectionHeight - viewportHeight;
      const inView = rect.top <= 10 && rect.top > -(sectionHeight - viewportHeight);

      if (this._dotNav) {
        this._dotNav.classList.toggle('iwtg__dot-nav--visible', inView);
      }

      if (scrollableRange <= 0) return;

      const scrolled = Math.max(0, -rect.top);
      const fraction = Math.min(scrolled / scrollableRange, 0.9999);
      const targetIndex = Math.min(
        Math.floor(fraction * this._items.length),
        this._items.length - 1
      );

      if (targetIndex !== this._currentIndex) {
        this._activateIndex(targetIndex, true);
      }
    }

    _activateIndex(index, animate) {
      const prev = this._currentIndex;
      this._currentIndex = index;

      this._items.forEach((item, i) => {
        if (i === prev && animate && i !== index) {
          item.classList.remove('iwtg__item--active');
          item.classList.add('iwtg__item--exit');
          const el = item;
          setTimeout(() => el.classList.remove('iwtg__item--exit'), 800);
        } else if (i !== index) {
          item.classList.remove('iwtg__item--active', 'iwtg__item--exit');
        }
      });

      const entering = this._items[index];
      entering.classList.remove('iwtg__item--exit');
      entering.classList.add('iwtg__item--active');

      this._dots.forEach((dot, i) => {
        dot.classList.toggle('iwtg__dot-nav__dot--active', i === index);
      });
    }
  }

  customElements.define('iwt-group', IwtGroup);
}
